export class AttendeeDTO {
    ambassadorCode: string;
    childCount: number = 0;
    createdAt: string = '';
    deleted: boolean = false;
    id: number;
    pastEvents: number = 0;
    privacyAccepted: boolean = false;
    profileCompleted: boolean = false;
    totalEvents: number = 0;
    updatedAt: string = '';
    userId: number;

    constructor(data: Partial<AttendeeDTO> = {}) {
        for (let key in data) {
            this[key] = data[key];
        }
    }
}
